<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/umexvI/tc-custom/9780795329326.jpg?1704537883291" alt="This image is the cover for the book In the Balance, Winston S. Churchill Post-War Speeches"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">In the Balance, Winston S. Churchill Post-War Speeches
      </h1>
      <p class="bookDescription body article font2">
        <b>This collection of speeches by the Nobel Prize-winning Prime Minister presents the addresses he delivered abroad between 1949 and 1950.</b><br/>  <br/> After guiding his country through the darkest times of World War II, Winston Churchill was defeated in the General Election of 1945. But he once again become Prime Minister in 1951. This collection features Churchill’s speeches, addresses, and other public communications in his period between terms. Churchill’s speaking engagements during this time took him across Europe—including to Brussels, Strasbourg, Copenhagen, and elsewhere—and across the Atlantic to the United States where he spoke in Boston and New York.<br/>  <br/> Major events during this period of history include the beginning of the Korean War, the devaluation of the British Pound Sterling, the creation of the North Atlantic Treaty Organization, and the United States’ rearmament program. Through these turbulent times, Churchill preached unity among European nations and English-speaking peoples worldwide.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Winston S. Churchill
      </h2>
      
      <p class="authorDescription body article">Sir Winston S. Churchill was awarded the Nobel Prize in Literature in 1953 "for his mastery of historical and biographical description as well as for brilliant oratory in defending exalted human values."  Over a 64-year span, Churchill published over 40 books, many multi-volume definitive accounts of historical events to which he was a witness and participant. All are beautifully written and as accessible and relevant today as when first published.  During his fifty-year political career, Churchill served twice as Prime Minister in addition to other prominent positions--including President of the Board of Trade, First Lord of the Admiralty, Chancellor of the Exchequer, and Home Secretary. In the 1930s, Churchill was one of the first to recognize the danger of the rising Nazi power in Germany and to campaign for rearmament in Britain. His leadership and inspired broadcasts and speeches during World War II helped strengthen British resistance to Adolf Hitler--and played an important part in the Allies' eventual triumph.  One of the most inspiring wartime leaders of modern history, Churchill was also an orator, a historian, a journalist, and an artist. All of these aspects of Churchill are fully represented in this collection of his works.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      RosettaBooks, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6962f4e9